// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"367":"60a97a7d","704":"1ec53d20"}[chunkId] + ".css";
};